module.exports = __webpack_public_path__ + "static/10-yose-zoom-031a058bcb03da7f6b5155f7be6b07aa.jpg";